var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 43C0.5 19.54 19.54 0.5 43 0.5C66.46 0.5 85.5 19.54 85.5 43C85.5 66.46 66.46 85.5 43 85.5C19.54 85.5 0.5 66.46 0.5 43ZM32.6667 66.2499C29.825 66.2499 27.5 63.9249 27.5 61.0833V35.2499C27.5 32.4083 29.825 30.0833 32.6667 30.0833H53.3333C56.175 30.0833 58.5 32.4083 58.5 35.2499V61.0833C58.5 63.9249 56.175 66.2499 53.3333 66.2499H32.6667ZM35.2513 35.25H50.7513C52.1721 35.25 53.3346 36.4125 53.3346 37.8333V58.5C53.3346 59.9208 52.1721 61.0833 50.7513 61.0833H35.2513C33.8305 61.0833 32.668 59.9208 32.668 58.5V37.8333C32.668 36.4125 33.8305 35.25 35.2513 35.25ZM50.2088 20.4992L52.043 22.3333H58.5013C59.9221 22.3333 61.0846 23.4958 61.0846 24.9167C61.0846 26.3375 59.9221 27.5 58.5013 27.5H27.5013C26.0805 27.5 24.918 26.3375 24.918 24.9167C24.918 23.4958 26.0805 22.3333 27.5013 22.3333H33.9596L35.7938 20.4992C36.2588 20.0342 36.9305 19.75 37.6021 19.75H48.4005C49.0721 19.75 49.7438 20.0342 50.2088 20.4992Z",
    fill: "url(#paint0_linear_7244_69785)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7244_69785",
    x1: 85.5,
    y1: 43,
    x2: -11.4776,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF59A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288566,
    stopColor: "#D12E7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678745,
    stopColor: "#D12E7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85144A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.c6c998369e2fbf72dd25d1488bbf9f24.svg";
export { ForwardRef as ReactComponent };